import { SitemapItem } from './sitemap-item'
import { TileMode } from './tile-mode'

export class AreaGroup extends SitemapItem {
  public items: SitemapItem[]
  public hideDescription: boolean
  public columns: number
  public tileMode: TileMode

  constructor(model: AreaGroup) {
    super(model)
    this.hideDescription = model.hideDescription
    this.items = this.mapItems(model.items)
    this.columns = model.columns
    this.tileMode = model.tileMode
  }

  public merge(area: AreaGroup): void {
    area.items.forEach((i) => {
      this.items.push(i)
    })
  }

  private mapItems(items: SitemapItem[]): SitemapItem[] {
    const mapped: SitemapItem[] = []
    if (items) {
      items.forEach((i) => {
        if (i.type == 'AreaGroup') mapped.push(new AreaGroup(i as AreaGroup))
        else mapped.push(i)
      })
    }
    return mapped
  }
}
